import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Layout } from "@circle-react/components/shared/CustomizeUI/Layout/Layout";
import {
  useCurrentSpaceContext,
  useSpaceResource,
} from "@circle-react/contexts";
import { reactQueryPatch } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { LessonButton } from "./LessonButton";
import { LESSON_STATUS } from "./constants";
import { useCompleteLessonMutation } from "./hooks/useCompleteLessonMutation";

export const LessonFooter = ({
  isDripped,
  isFeaturedMediaCompleted,
  shouldEnforceFeaturedMediaCompletion,
  lesson,
  refetchLesson,
  lastAttempt,
  shouldEnforcePassingGrade,
}) => {
  const { data: space } = useCurrentSpaceContext();
  const { refetch: refetchSpace, isLoading: isSpaceResourceIsLoading } =
    useSpaceResource({
      spaceId: space?.id,
    });
  const params = useParams();

  const completeLessonMutation = useCompleteLessonMutation({
    space,
    refetchSpace,
    refetchLesson,
  });

  // Incomplete lesson mutation
  const incompleteLessonMutation = useMutation(
    () =>
      reactQueryPatch(
        internalApi.courses.lessonProgress.update({
          courseId: space.id,
          lessonId: params.lessonId,
        }),
        {
          status: LESSON_STATUS.INCOMPLETE,
        },
      ),
    {
      onSuccess: () => {
        refetchSpace();
        refetchLesson();
      },
    },
  );

  if (isSpaceResourceIsLoading || !isDripped) {
    return null;
  }

  return (
    <Layout.Footer>
      <div className="flex justify-center py-3">
        <LessonButton
          isCompleted={lesson?.completed}
          isFeaturedMediaCompleted={isFeaturedMediaCompleted}
          shouldEnforceFeaturedMediaCompletion={
            shouldEnforceFeaturedMediaCompletion
          }
          isLoading={
            completeLessonMutation.isLoading ||
            incompleteLessonMutation.isLoading
          }
          onClick={
            lesson?.completed
              ? incompleteLessonMutation.mutate
              : completeLessonMutation.mutate
          }
          loadingText={t("courses.view_lesson.updating")}
          lastAttempt={lastAttempt}
          shouldEnforcePassingGrade={shouldEnforcePassingGrade}
        />
      </div>
    </Layout.Footer>
  );
};
